module.exports = __webpack_public_path__ + "img/dabaofangshi.2be12027.jpg";